<template>
  <div class="d-flex justify-content-center mt-5 pt-4">
    <EmptyStateComponent
        :icon="iconWarning"
        :icon-style="{ width: '17px', height: '17px' }"
        :title="$t('general.notFoundTitle')"
        :text="$t('general.notFoundText')"
    >
      <router-link :to="{ name: 'Dashboard' }" class="btn btn-primary app-nav__create-btn">
        {{ $t('general.backToDashboard') }}
      </router-link>
    </EmptyStateComponent>
  </div>
</template>

<script>
import EmptyStateComponent from '../components/EmptyStateComponent.vue';
import iconWarning from '/public/img/new-design/icons/warning.svg';

export default {
  components: { EmptyStateComponent },
  data() {
    return { iconWarning };
  },
};
</script>
